/* eslint-disable @typescript-eslint/no-explicit-any */

import type { RunOptions } from 'axe-core';

export async function initAxe() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const axe = await import('@axe-core/react');
  const React = require('react');
  const ReactDOM = require('react-dom');

  const options: RunOptions = {
    runOnly: {
      type: 'tag',
      values: ['wcag2a', 'wcag2aa'],
    },
    rules: [
      { id: 'color-contrast', enabled: true },
      { id: 'image-alt', enabled: true },
      { id: 'label', enabled: true },
      { id: 'button-name', enabled: true },
      { id: 'aria-roles', enabled: true },
      { id: 'duplicate-id', enabled: true },
      { id: 'tabindex', enabled: true },
      { id: 'heading-order', enabled: true },
      { id: 'landmark-one-main', enabled: true },
      { id: 'region', enabled: false },
    ] as any,
  };

  // Cast to any to silence the ReactSpec type mismatch
  axe.default(React, ReactDOM, 1000, options as any);
}
